import { FLAGS_UPDATE } from '../actions/flags';

export const DEFAULT_REPORT = true;
export const DEFAULT_LOCAL = false;

const defaultState = {
  report: DEFAULT_REPORT, // report analytics
  local: DEFAULT_LOCAL, // use local data buffer when viewing samples
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case FLAGS_UPDATE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export const flagsSelector = (state) => state.flags;
